import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ECOM_PLATFORM_APP_DEF_ID, PageMap } from '../../utils/consts';
import { addWhiteListParamsToUrl } from '../../utils/whiteListParams';
import { isValidHttpUrl } from '../../utils/isValidHttpUrl';
export class NavigationService {
  constructor(controllerConfig, options) {
    this.controllerConfig = controllerConfig;
    _defineProperty(this, "continueShoppingUrl", void 0);
    _defineProperty(this, "successUrl", void 0);
    this.continueShoppingUrl = options?.continueShoppingUrl;
    this.successUrl = options?.successUrl;
  }
  async getThankYouPageUrlForPlaceOrder() {
    if (this.successUrl && isValidHttpUrl(this.successUrl)) {
      return this.successUrl.replace('{objectType}', 'order');
    }
    const {
      url
    } = await this.getSectionUrl(PageMap.THANK_YOU_PAGE);
    const orderIdPlaceholder = 'orderIdPlaceholder';
    const thankYouPageUrl = new URL(`${url}/${orderIdPlaceholder}`);
    const appSectionParams = JSON.stringify({
      objectType: 'order',
      origin: 'checkout',
      ...(this.continueShoppingUrl && {
        continueShoppingUrl: this.continueShoppingUrl
      })
    });
    thankYouPageUrl.searchParams.set('appSectionParams', appSectionParams);
    addWhiteListParamsToUrl(thankYouPageUrl, this.controllerConfig.wixCodeApi.location.url);
    return thankYouPageUrl.toString().replace('orderIdPlaceholder', '{orderId}');
  }
  async getCheckoutErrorUrl(checkout, cashierPaymentId, contentAppId, contentComponentId) {
    const checkoutErrorUrl = await this.getCheckoutUrl(checkout, cashierPaymentId, contentAppId, contentComponentId);
    checkoutErrorUrl.searchParams.set('redirect', 'error');
    addWhiteListParamsToUrl(checkoutErrorUrl, this.controllerConfig.wixCodeApi.location.url);
    return checkoutErrorUrl.toString();
  }
  async getCheckoutCancelUrl(checkout, cashierPaymentId, contentAppId, contentComponentId) {
    const checkoutCancelUrl = await this.getCheckoutUrl(checkout, cashierPaymentId, contentAppId, contentComponentId);
    checkoutCancelUrl.searchParams.set('redirect', 'cancel');
    return checkoutCancelUrl.toString();
  }
  async navigateToThankYouPage(orderId) {
    if (this.successUrl && isValidHttpUrl(this.successUrl)) {
      return this.navigateToExternalSuccessPage(orderId);
    }
    const {
      url
    } = await this.getSectionUrl(PageMap.THANK_YOU_PAGE);
    const thankYouPageUrl = new URL(`${url}/${orderId}`);
    thankYouPageUrl.searchParams.set('appSectionParams', JSON.stringify({
      objectType: 'order',
      origin: 'cashier-express-directly-to-typ',
      ...(this.continueShoppingUrl && {
        continueShoppingUrl: this.continueShoppingUrl
      })
    }));
    return this.controllerConfig.wixCodeApi.location.to?.(thankYouPageUrl.toString());
  }
  async navigateToExternalSuccessPage(orderId) {
    const externalSuccessUrl = this.successUrl.replace('{orderId}', orderId).replace('{objectType}', 'order');
    return this.controllerConfig.wixCodeApi.location.to?.(externalSuccessUrl);
  }
  async getCheckoutUrl(_ref, cashierPaymentId, contentAppId, contentComponentId) {
    let {
      id
    } = _ref;
    const {
      url
    } = await this.getSectionUrl(PageMap.CHECKOUT);
    const checkoutUrl = new URL(url);
    const queryParams = {
      checkoutId: id,
      ...(this.continueShoppingUrl && {
        continueShoppingUrl: this.continueShoppingUrl
      }),
      ...(this.successUrl && {
        successUrl: this.successUrl.replace('{objectType}', 'order')
      }),
      cashierPaymentId,
      ...(contentAppId && {
        contentAppId
      }),
      ...(contentComponentId && {
        contentComponentId
      })
    };
    Object.entries(queryParams).forEach(_ref2 => {
      let [key, value] = _ref2;
      checkoutUrl.searchParams.set(key, value);
    });
    addWhiteListParamsToUrl(checkoutUrl, this.controllerConfig.wixCodeApi.location.url);
    return checkoutUrl;
  }
  async navigateToCheckout(checkout, cashierPaymentId) {
    const checkoutUrl = await this.getCheckoutUrl(checkout, cashierPaymentId);
    return this.controllerConfig.wixCodeApi.location.to?.(checkoutUrl.toString());
  }
  getSectionUrl(sectionId) {
    const params = {
      sectionId,
      appDefinitionId: ECOM_PLATFORM_APP_DEF_ID
    };
    return this.controllerConfig.wixCodeApi.site.getSectionUrl(params, false);
  }
}
//# sourceMappingURL=NavigationService.js.map